import styles from './styles.module.css';
import { InputHTMLAttributes, useId } from 'react';

type Props = {
  label: string;
} & Omit<InputHTMLAttributes<HTMLInputElement>, 'id' | 'type' | 'className'>;

function ToggleSwitch({ label, ...props }: Props) {
  const id = useId();
  return (
    <span className={styles.container}>
      <label htmlFor={id} className={styles.label}>
        {label}
      </label>
      <input {...props} id={id} type="checkbox" className={styles.checkbox} />
    </span>
  );
}

export default ToggleSwitch;
